import './main.less';
import React from 'react';
import PropTypes from 'prop-types';
import { Field, reduxForm } from 'redux-form';
import Textarea from '../../../../../shared/form-elements/textarea';

const Main = props => {
	const {
		submitComment, handleSubmit, showCommentSubmitBtn, setShowCommentSubmitBtn, intl,
		submitNote, isNote = false
	} = props;
	const submitMethod = isNote ? submitNote : submitComment;

	return (
		<div className="profile__comment-form">
			<form onSubmit={handleSubmit(data => submitMethod(data))}>
				<Field
					name="comment"
					placeholder={intl(isNote ? 'Add a note' : 'Add a comment')}
					onFocus={setShowCommentSubmitBtn}
					initialHeight={'50'}
					component={Textarea}
				/>
				{showCommentSubmitBtn &&
				<button className="ui-btn ui-btn-primary">
					{intl('Submit')}
				</button>}
			</form>
		</div>
	);
};

Main.propTypes = {
	submitComment: PropTypes.func,
	handleSubmit: PropTypes.func,
	showCommentSubmitBtn: PropTypes.bool,
	setShowCommentSubmitBtn: PropTypes.func,
	intl: PropTypes.func
};

export default reduxForm({
	form: 'affiliateProfileCommentForm'
})(Main);



// WEBPACK FOOTER //
// ./frontend/admin-dashboard/src/modules/affiliates/components/profile/forms/comment/main.js